import React from 'react'

import { ZariContext } from '_zari/context'

import * as AuthService from 'services/auth.service'
import * as LicenciaService from 'services/licencia.service'

const AdminContext = React.createContext({
  mesTrabajo: null,
  setMesTrabajo: null,
  anioTrabajo: null,
  nombreCompania: null,
  modalidadCalculoDeDepreciacion: null,
  flagAltoBajo: null,
  flagPaseConsumos: null,
  flag1500Uit: null,
  flagUsoPresupuesto: null,
  usuario: '',
  transacciones: [],
  flagCuentasRequeridasCentroCosto: null
})

const { Provider } = AdminContext

const AdminProvider = props => {
  const __zariContext = React.useContext(ZariContext)

  const [mesTrabajo, setMesTrabajo] = React.useState(null)
  const [anioTrabajo, setAnioTrabajo] = React.useState(null)
  const [nombreCompania, setNombreCompania] = React.useState('')
  const [modalidadCalculoDeDepreciacion, setModalidadCalculoDeDepreciacion] = React.useState('')
  const [flagAltoBajo, setFlagAltoBajo] = React.useState('')
  const [flagPaseConsumos, setFlagPaseConsumos] = React.useState('')
  const [flag1500Uit, setFlag1500Uit] = React.useState('')
  const [flagUsoPresupuesto, setFlagUsoPresupuesto] = React.useState('')
  const [usuario, setUsuario] = React.useState('')
  const [transacciones, setTransacciones] = React.useState([])
  const [flagCuentasRequeridasCentroCosto, setFlagCuentasRequeridasCentroCosto] = React.useState('')
  const oneTryRef = React.useRef(false)

  React.useEffect(() => {
    AuthService.getSesionInfo()
      .then(({ data }) => {
        setMesTrabajo(data.mesTrabajo)
        setAnioTrabajo(data.anioTrabajo)
        setNombreCompania(data.compania)
        setModalidadCalculoDeDepreciacion(data.modalidadCalculoDeDepreciacion)
        setFlag1500Uit(data.flag1500Uit)
        setFlagAltoBajo(data.flagAltoBajo)
        setFlagPaseConsumos(data.flagPaseConsumos)
        setFlagUsoPresupuesto(data.flagUsoPresupuesto)
        setTransacciones(data.transacciones)
        setFlagCuentasRequeridasCentroCosto(data.flagCuentasRequeridasCentroCosto)
        setUsuario(data.usuario || 'Usuario')
      })
      .catch(() => console.log('error', 'No se ha podido obtener la fecha de trabajo.'))
  }, [])

  React.useEffect(() => {
    if (!oneTryRef.current) {
      LicenciaService.validarLicencia()
        .then(({ data }) => {
          if (data && data.mensaje) {
            __zariContext.snack('warning', data.mensaje)
          }
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
      oneTryRef.current = true
    }
  }, [__zariContext])

  return (
    <Provider
      value={{
        mesTrabajo,
        setMesTrabajo,
        anioTrabajo,
        nombreCompania,
        modalidadCalculoDeDepreciacion,
        flagAltoBajo,
        flag1500Uit,
        flagPaseConsumos,
        flagCuentasRequeridasCentroCosto,
        flagUsoPresupuesto,
        usuario,
        transacciones
      }}
    >
      {props.children}
    </Provider>
  )
}

export { AdminContext, AdminProvider }

